@if(model$ | async; as model) {
<div class="modal-header">
  <h4 class="modal-title">Edit Profile</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  ></button>
</div>

<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-body">
    @if (error) {
    <div class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    }

    <formly-form [form]="form" [fields]="formFields" [model]="model">
    </formly-form>
  </div>

  <div class="modal-footer d-flex justify-content-between">
    <div>
      <!-- No delete button for profile modal -->
    </div>
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-outline-dark" (click)="closeModal()">
        Close
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!form.valid || isLoading"
      >
        @if (isLoading) {
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        } Save
      </button>
    </div>
  </div>
</form>
}
